<template>
    <div class="x_box A4">
        <div class="x_body">
            <div class="print-header font-m">
                <h2 class="text-center" style="font-weight: bold;">{{company.Name}}</h2>
            </div>
            <h4 class="text-center font-m" style="font-weight: bold;">{{$t('report_price_list')}}</h4>
            <div class="row">
                <div class="col-sm-12">
                    <table class="table table-bordered table-striped table-sm no-bor">
                        <thead>
                            <tr>
                                <th>{{$t('no')}}</th>
                                <th>{{$t('barcode')}}</th>
                                <th>{{$t('name')}}</th>
                                <th>{{$t('category')}}</th>
                                <th class="text-right">{{ $t('cost') }}</th>
                                <th class="text-right">{{ $t('price') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret,index) in records" :key="index">
                                <td>{{index+1}}</td>
                                <td>{{ret.Num}}</td>
                                <td>{{ret.Name}}</td>
                                <td>{{ret.CategoryName}}</td>
                                <td class="text-right">{{$money(ret.Cost)}}</td>
                                <td class="text-right">{{$money(ret.Price)}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  data: function() {
    return {
      company: {
        Name: ''
      },
      records: []
    };
  },
  created: function() {
    this.getCompany();
    let loading = this.$loading.show();
    this.$api().post('report/item/list').then(res => {
        this.records = res.data.Json.Items;
    }).finally(function() {
        loading.hide();
    });
  },
  methods: {
    getCompany: function() {
      this.$api().post("company").then(res => {
        if(res.data.Data != null)
          this.company = res.data.Data;
      });
    }
  }
};
</script>
<style scoped>
body {
  font-size: 14px;
}
</style>